// src/components/reports/PDFSolicitudesExporter.jsx
import React from "react";
import { Button } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../assets/logo.png";// Ajustar ruta según tu estructura

const PDFSolicitudesExporter = ({ data, fileName = "solicitudes.pdf" }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 0,
    }).format(amount || 0);
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("es-AR");
    } catch {
      return "N/A";
    }
  };

  const handleGeneratePDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");

    // Logo
    const img = new Image();
    img.src = logo;
    await new Promise((resolve) => (img.onload = resolve));
    doc.addImage(img, "PNG", 15, 10, 35, 15);

    // Título
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Reporte de Solicitudes", 105, 18, { align: "center" });

    // Subtítulo
    const fecha = new Date().toLocaleString("es-AR");
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Generado el ${fecha}`, 105, 25, { align: "center" });

    // Encabezados
    const headers = [
      "ID",
      "Tipo",
      "Nombre",
      "DNI",
      "Email",
      "Monto",
      "Fecha",
      "Estado",
    ];

    // Filas
    const body = data.map((s) => [
      s.id.substring(0, 8),
      s.tipo,
      s.nombre,
      s.dni,
      s.email,
      formatCurrency(s.montoSolicitado),
      formatDate(s.fechaCreacion),
      s.estado,
    ]);

    // Tabla
    autoTable(doc, {
      startY: 35,
      head: [headers],
      body,
      styles: { fontSize: 9, halign: "center" },
      headStyles: { fillColor: [0, 50, 38], textColor: 255 },
    });

    doc.save(fileName);
  };

  return (
    <Button
      variant="contained"
      color="error"
      onClick={handleGeneratePDF}
      startIcon={<PictureAsPdfIcon />}
      sx={{
        textTransform: "none",
        backgroundColor: "#d13438",
        ":hover": { backgroundColor: "#a7282d" },
      }}
    >
      Exportar Solicitudes
    </Button>
  );
};

export default PDFSolicitudesExporter;
